import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initGA, trackPageView } from './utils/analytics';

// 初始化 Google Analytics
initGA();

// 跟踪初始页面浏览
trackPageView(window.location.pathname, document.title);

// 监听路径变化（因为使用的是简单的路径匹配，不是 React Router）
let lastPath = window.location.pathname;
const checkPathChange = () => {
  const currentPath = window.location.pathname;
  if (currentPath !== lastPath) {
    trackPageView(currentPath, document.title);
    lastPath = currentPath;
  }
};

// 使用 MutationObserver 监听 DOM 变化（当路径改变时）
const observer = new MutationObserver(checkPathChange);
observer.observe(document.body, {
  childList: true,
  subtree: true
});

// 监听 popstate 事件（浏览器前进/后退）
window.addEventListener('popstate', () => {
  trackPageView(window.location.pathname, document.title);
  lastPath = window.location.pathname;
});

// 拦截 pushState 和 replaceState（程序化导航）
const originalPushState = window.history.pushState;
const originalReplaceState = window.history.replaceState;

window.history.pushState = function(...args) {
  originalPushState.apply(window.history, args);
  setTimeout(() => {
    trackPageView(window.location.pathname, document.title);
    lastPath = window.location.pathname;
  }, 0);
};

window.history.replaceState = function(...args) {
  originalReplaceState.apply(window.history, args);
  setTimeout(() => {
    trackPageView(window.location.pathname, document.title);
    lastPath = window.location.pathname;
  }, 0);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
